/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Checkbox } from 'antd'
import { Fragment, useState } from 'react'
import { observer } from 'mobx-react'
import * as _ from 'lodash'
import { isMobile } from 'react-device-detect'
import { PROPERTY_ID } from 'adv-protocol/src/GameCommon'
import useRootStore from '@store/useRootStore'
import { useOnMount } from '@utils/reactExt'
import { VIEW_TYPE } from '@constants/index'
import { UserItem } from '@store/userStore'
import { formatNumber } from '@utils/utils'
import { UserItemRootWrap } from './index.style'

interface MyItemProps {
  propertyIds: PROPERTY_ID[]
  viewType: VIEW_TYPE
  setSelectedUserItemToParent: (item: UserItem, itemCount: number) => void
}

const MyItem = (props: MyItemProps) => {
  const { userStore } = useRootStore()
  const { userItems = [], userCharacter } = userStore
  const { propertyIds = [], viewType, setSelectedUserItemToParent } = props
  // const [selectedItemCount, setSelectedItemCount] = useState('0')
  const [selectedItem, setSelectedItem] = useState<UserItem>(null)
  const userCharacterItem = _.find(userItems, { link_index: userCharacter })

  const fetchUserItems = async () => {
    await userStore.getUserItems(props.propertyIds)
  }

  useOnMount(async () => {
    await fetchUserItems()
  })

  if (!selectedItem && viewType === VIEW_TYPE.SKIN_SELECTOR && !_.isEmpty(userItems) && userCharacterItem) {
    setSelectedItem(userCharacterItem)
  }

  const onChangeUserItemSelectionHandler = (event, selectItem: UserItem) => {
    // NOTE: IOS에서만 발생하는 이슈로 수량 증감을 버튼으로 입력시에도 이 핸들러를 탄다.(원인파악은 못한상황)
    //       2가지 경우의 수로 이벤트가 발생한다
    //       1. 선물할 아이템을 클릭했을 경우.
    //       2. 선택한 아이템의 수량버튼을 눌렀을 경우 ( 이 경우는 IOS에서만 발생함)
    //       선물을 선택할 경우에만 호출되어야 하므로 target.checked가 true일 경우에만 태우도록 조건처리
    if (event.target.checked) {
      // if (selectedItem && selectedItem.id !== selectItem.id) {
      //   setSelectedItemCount('0')
      // }
      setSelectedUserItemToParent(selectItem, 0)
      setSelectedItem(selectItem)
    }
  }

  // const validationItemCount = (targetItem: UserItem, itemCount: number): boolean => {
  //   if (!selectedItem) {
  //     return false
  //   }
  //   if (selectedItem.id !== targetItem.id) {
  //     return false
  //   }
  //   if (itemCount < 0) {
  //     return false
  //   }
  //   if (selectedItem.quantity < itemCount) {
  //     return false
  //   }
  //   // 유저가 사용중인 스킨 1개를 제외 하고 카운트
  //   if (userCharacterItem && selectedItem.id === userCharacterItem.id && (selectedItem.quantity - 1) < itemCount) {
  //     return false
  //   }
  //   return true
  // }

  // const onClickItemCountHandler = (targetItem: UserItem, itemCount: number) => {
  //   // NOTE: selectedItemCount의 값을 숫자로 입력할 경우 input창에 012라고 입력한 뒤
  //   //       setSelectItemCount의 값을 12로 바꿔도 인풋창에는 012로 보여지기때문에 문자로 수정
  //   const newCount = Number(selectedItemCount) + itemCount
  //   if (validationItemCount(targetItem, newCount)) {
  //     setSelectedItemCount(newCount.toString())
  //     setSelectedUserItemToParent(targetItem, newCount)
  //   }
  // }
  //
  // const onChangeItemCountHandler = (event: ChangeEvent<HTMLInputElement>, targetItem: UserItem) => {
  //   const newCount = Number(event.target.value)
  //   if (validationItemCount(targetItem, newCount)) {
  //     setSelectedItemCount(newCount.toString())
  //     setSelectedUserItemToParent(targetItem, newCount)
  //   }
  // }

  const userItemComponents = []
  for (const userItem of userItems) {
    if (!_.isEmpty(propertyIds) && !propertyIds.includes(userItem.propertyId)) {
      continue
    }

    const checkboxKey = `UserItem:Checkbox:${userItem.id}`
    userItemComponents.push(
      <Checkbox
        key={checkboxKey}
        className="check-box"
        checked={selectedItem && selectedItem.id === userItem.id}
        onChange={(event) => onChangeUserItemSelectionHandler(event, userItem)}
      >
        <div className="skin-info" key={userItem.id}>
          <div className="skin-img-wrap">
            <img src={userItem.icon_m} alt="스킨 이미지" className="skin-img"/>
          </div>
          <div className="skin-quantity">{formatNumber(userItem.quantity)}</div>
          <div className="skin-name">{userItem.name}</div>
        </div>

        {/*{viewType === VIEW_TYPE.GIF_SELECTOR && (*/}
        {/*  <NumInputGroup className="my-item num-input-group">*/}
        {/*    <Button className="left btn" onClick={() => onClickItemCountHandler(userItem, -1)}>*/}
        {/*      &#45;*/}
        {/*    </Button>*/}
        {/*    <Input*/}
        {/*      type="number"*/}
        {/*      pattern="\d*"*/}
        {/*      defaultValue="1"*/}
        {/*      value={(selectedItem && selectedItem.id === userItem.id) ? selectedItemCount : '0'}*/}
        {/*      onChange={(e) => onChangeItemCountHandler(e, userItem)}*/}
        {/*      maxLength={50}*/}
        {/*      className="input"*/}
        {/*    />*/}
        {/*    <Button className="right btn" onClick={() => onClickItemCountHandler(userItem, 1)}>*/}
        {/*      &#43;*/}
        {/*    </Button>*/}
        {/*  </NumInputGroup>*/}
        {/*)}*/}
      </Checkbox>
      ,
    )
  }

  return (
    <Fragment>
      <UserItemRootWrap className={isMobile ? '' : 'pc'} css={{ marginBottom: '40px' }}>{userItemComponents}</UserItemRootWrap>
    </Fragment>
  )
}

export default observer(MyItem)
